
















































































































































































































































































































































































































import { Element, ElementStatusPhase, ElementType, Milestone, MilestoneDate, Product, SearchMilestoneOptions } from '@/models'
import { Component, Prop, Vue } from 'vue-property-decorator'
import { CV_VALUE_COUNTRY_ES } from '@/utils/constants'
import ApiClient from '@/services/api-client'
import { ActionTypes } from '@/store/action-types'
import { Utils } from '@/utils'

interface NumberMap {
  [index: number]: string;
}
interface BooleanMap {
  [index: number]: boolean;
}
@Component({})
export default class UpsertTracingProductModal extends Vue {
  @Prop({ required: false }) product: Product

  private stateAccordion: BooleanMap = {}
  private stateAccordionType: BooleanMap = {}
  private stateUpdateMilestoneDate: BooleanMap = {}

  private elementToAddMilestone: Element | null = null
  private elementToAddMilestoneType: Element | null = null
  private milestones: Milestone[] = []

  private phase: NumberMap = {}
  private percentagePhase: NumberMap = {}
  private deadlineDate: NumberMap = {}

  private phaseUpdate: NumberMap = {}
  private percentagePhaseUpdate: NumberMap = {}
  private deadlineDateUpdate: NumberMap = {}

  get elementsToDefineMilestone() {
    const elementTypesDefineMilestone = this.elementTypes.filter((elementType: ElementType) => elementType.defineMilestone === true).map((elementType: ElementType) => elementType.codeId)
    const elementsList = Utils.flattenTreeNodes(this.product.elements, 'elements')
    const milestoneWithElementsIdUsed = this.milestonesWithElement.map(milestone => milestone.elementId)
    return elementsList.filter((element: Element) => elementTypesDefineMilestone.includes(element.type) && !milestoneWithElementsIdUsed.includes(parseInt(element.id)))
  }

  get elementsTypeToDefineMilestone() {
    const elementTypesDefineMilestone = this.elementTypes.filter((elementType: ElementType) => elementType.defineMilestone === true).map((elementType: ElementType) => elementType.codeId)
    const elementTypeUsed = this.milestonesElementType.map(milestone => milestone.elementTypeId)
    const elementsList = Utils.flattenTreeNodes(this.product.elements, 'elements')
    const elementsFiltered = elementsList.filter((element: Element) => elementTypesDefineMilestone.includes(element.type) && !elementTypeUsed.includes(element.type))
    return this.groupByFirstFlat(elementsFiltered, 'type')
  }

  get elementTypes(): ElementType[] {
    return this.$store.state.elementTypes
  }

  get milestonesWithElement() {
    return this.milestones.filter(milestone => milestone.elementId)
  }

  get milestonesElementType() {
    return this.milestones.filter(milestone => !milestone.elementId)
  }

  get elementStatusPhases(): ElementStatusPhase[] {
    const elementStatusPhases = this.$store.state.elementStatusPhases.filter((elementStatusPhase: ElementStatusPhase) =>
      elementStatusPhase.editorialProjectId === this.product.editorialProject &&
      elementStatusPhase.country === this.product.country)
    return elementStatusPhases
  }

  private groupByFirstFlat(array: Array<any>, key: string) {
    const seen = new Set()
    return array.filter(obj => {
      if (!seen.has(obj[key])) {
        seen.add(obj[key])
        return true
      }
      return false
    })
  }

  private resetModal() {
    this.loadElementStatusPhases()
    this.loadMilestone()
  }

  private async loadMilestone() {
    const searchOptions: SearchMilestoneOptions = {
      productId: parseInt(this.product.id),
      limit: 100
    }
    const result = await ApiClient.searchMilestones(searchOptions)
    this.milestones = result.items

    const elementsList = Utils.flattenTreeNodes(this.product.elements, 'elements')

    // Complete milestone with element
    for (const milestone of this.milestones) {
      const elementFind = elementsList.find(element => parseInt(element.id) === milestone.elementId)
      milestone.elementObject = elementFind

      if (milestone.milestoneDates) {
        for (const milestoneDate of milestone.milestoneDates) {
          const phase = this.elementStatusPhases.find(item => item.elementStatusPhaseId === milestoneDate.phase)
          milestoneDate.phaseObject = phase
        }
      }
    }
  }

  private async loadElementStatusPhases() {
    await this.$store.dispatch(ActionTypes.GET_ELEMENT_STATUS_PHASES, { editorialProjectId: this.product.editorialProject, country: this.product.country })
  }

  hideModal() {
    this.$bvModal.hide('upsertTracingProductModal')
  }

  private async addMilestoneFromElement(productLevel = false) {
    let type = ''
    if (this.elementToAddMilestone && !productLevel) {
      type = this.elementToAddMilestone.type
    } else if (this.elementToAddMilestoneType && productLevel) {
      type = this.elementToAddMilestoneType.type
    }

    const milestone: Milestone = {
      milestoneId: 0,
      campaign: this.product.metadata.campaign ? parseInt(this.product.metadata.campaign) : new Date().getFullYear(),
      editorialProjectId: this.product.editorialProject ? this.product.editorialProject : '',
      country: this.product.country ? this.product.country : CV_VALUE_COUNTRY_ES,
      productId: parseInt(this.product.id),
      elementTypeId: type,
      milestoneDates: []
    }

    if (!productLevel && this.elementToAddMilestone) {
      milestone.elementId = parseInt(this.elementToAddMilestone.id)
    }

    try {
      const resultCreate = await ApiClient.createMilestone(milestone)

      if (!productLevel) {
        milestone.elementObject = this.elementToAddMilestone
      }
      milestone.milestoneId = resultCreate.milestoneId
      this.milestones.push(milestone)

      // Clear select
      if (productLevel) {
        this.elementToAddMilestoneType = null
      } else {
        this.elementToAddMilestone = null
      }
    } catch (error) {
      console.log('Error create milestone', error)
    }
  }

  private async removeMilestone(milestone: Milestone) {
    try {
      ApiClient.deleteMilestone(milestone.milestoneId)
      const index = this.milestones.findIndex(item => item.milestoneId === milestone.milestoneId)
      this.milestones.splice(index, 1)
    } catch (error) {
      console.log('Error delete milestone', error)
    }
  }

  private async addMilestoneDate(milestone: Milestone) {
    if (!milestone || !milestone.milestoneDates) {
      return false
    }

    const milestoneDate: MilestoneDate = {
      milestoneDateId: 0,
      milestoneId: milestone.milestoneId,
      phase: this.phase[milestone.milestoneId],
      percentagePhase: parseInt(this.percentagePhase[milestone.milestoneId]),
      deadlineDate: this.deadlineDate[milestone.milestoneId]
    }

    try {
      const resultCreate = await ApiClient.createMilestoneDate(milestoneDate)

      const phase = this.elementStatusPhases.find(item => item.elementStatusPhaseId === milestoneDate.phase)
      resultCreate.phaseObject = phase
      milestone.milestoneDates.push(resultCreate)

      this.clearFormMilestoneDate(milestone)
    } catch (error) {
      console.log('Error create milestone date', error)
    }
  }

  private async removeMilestoneDate(milestone: Milestone, milestoneDate: MilestoneDate, index: number) {
    if (milestone && milestone.milestoneDates && index >= 0 && index < milestone.milestoneDates.length) {
      try {
        ApiClient.deleteMilestoneDate(milestoneDate.milestoneDateId)
        milestone.milestoneDates.splice(index, 1)
      } catch (error) {
        console.log('Error delete milestone date', error)
      }
    }
  }

  private async editMilestoneDate(milestoneDate: MilestoneDate) {
    Vue.set(this.stateUpdateMilestoneDate, milestoneDate.milestoneDateId, true)

    Vue.set(this.phaseUpdate, milestoneDate.milestoneDateId, milestoneDate.phase)
    Vue.set(this.deadlineDateUpdate, milestoneDate.milestoneDateId, milestoneDate.deadlineDate)
    Vue.set(this.percentagePhaseUpdate, milestoneDate.milestoneDateId, milestoneDate.percentagePhase)
  }

  private async updateMilestoneDate(milestoneDate: MilestoneDate) {
    milestoneDate.phase = this.phaseUpdate[milestoneDate.milestoneDateId]
    milestoneDate.deadlineDate = this.deadlineDateUpdate[milestoneDate.milestoneDateId]
    milestoneDate.percentagePhase = parseInt(this.percentagePhaseUpdate[milestoneDate.milestoneDateId])

    const milestoneDateCopy = JSON.parse(JSON.stringify(milestoneDate))
    delete milestoneDateCopy.phaseObject
    try {
      await ApiClient.updateMilestoneDate(milestoneDateCopy)

      const phase = this.elementStatusPhases.find(item => item.elementStatusPhaseId === milestoneDate.phase)
      milestoneDate.phaseObject = phase
      this.cancelUpdateMilestoneDate(milestoneDate)
    } catch (error) {
      console.log('Error create milestone', error)
    }
  }

  private async cancelUpdateMilestoneDate(milestoneDate: MilestoneDate) {
    Vue.set(this.stateUpdateMilestoneDate, milestoneDate.milestoneDateId, false)

    Vue.set(this.phaseUpdate, milestoneDate.milestoneDateId, null)
    Vue.set(this.deadlineDateUpdate, milestoneDate.milestoneDateId, null)
    Vue.set(this.percentagePhaseUpdate, milestoneDate.milestoneDateId, null)
  }

  private clearFormMilestoneDate(milestone: Milestone) {
    Vue.delete(this.phase, milestone.milestoneId)
    Vue.delete(this.percentagePhase, milestone.milestoneId)
    Vue.delete(this.deadlineDate, milestone.milestoneId)
  }

  private getElementTypeName(codeId: string) {
    return Utils.findElementTypeName(codeId, this.$store.getters.elementTypes)
  }

  private orderMilestoneDate(milestoneDates: MilestoneDate[]) {
    return milestoneDates ? milestoneDates.slice().sort((a, b) => {
      const dateA = new Date(a.deadlineDate).getTime()
      const dateB = new Date(b.deadlineDate).getTime()
      return dateA - dateB
    }) : []
  }
}
